<div fxLayout="row" fxLayoutAlign="start center" class="transcription-paragraph__container">
  <div style="margin-right: 20px" fxLayoutAlign="start center">
    <transcript-sentiment-icon
      [sentiment]="paragraph.sentiment"
      [sentimentScore]="paragraph.sentiment_score"
    ></transcript-sentiment-icon>
  </div>
  <span
    ><strong>{{ speakerLabel }}</strong> {{ paragraphText }}</span
  >
</div>
